module.exports = __webpack_public_path__ + "media/images/emblems/Root_LU-4eba0b2421e43659e536921564bd4dba.png";